import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import { COUNTRY_SHORT_NAME } from '@commons/constants';

const Lazy = path =>
  loadable(() => import(`./${path}`), {
    fallback: null,
  });

function Taxes({ taxes, country }) {
  const T = useMemo(
    () =>
      taxes && country === COUNTRY_SHORT_NAME.PANAMA
        ? Lazy('AppetitoTaxes')
        : null,
    [country, taxes],
  );

  if (!T) return null;
  return <T taxes={taxes} />;
}

Taxes.propTypes = {
  taxes: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
};

export default Taxes;
